module.exports = __webpack_public_path__ + "img/ic_folder-plus.f9b048c5.svg";